import { render, staticRenderFns } from "./HomeFeaturedTherapist.vue?vue&type=template&id=b087f58e&scoped=true&"
import script from "./HomeFeaturedTherapist.vue?vue&type=script&lang=ts&"
export * from "./HomeFeaturedTherapist.vue?vue&type=script&lang=ts&"
import style0 from "./HomeFeaturedTherapist.vue?vue&type=style&index=0&id=b087f58e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b087f58e",
  null
  
)

export default component.exports